var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
define('baseline/tables',["require", "exports", "../dom", "../geo/geo", "../places/places", "../tracks/track", "../tracks/track-store", "../util/convert"], function (require, exports, dom_1, geo_1, places_1, track_1, trackStore, convert_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.initAdmin = exports.initExit = exports.init = void 0;
    var dateColumn = {
        data: "date_string",
        render: function (d, t, row) {
            if (t === "sort") {
                // Leading zero for dates before 2001
                return row.date >= 1000000000000 ? "" + row.date : "0" + row.date;
            }
            else if (t === "display") {
                return "<a href=\"/tracks/" + row.track_id + "\">" + d + "</a>";
            }
            else {
                // Filter on..
                return d;
            }
        }
    };
    var altColumn = {
        data: "stats.alt",
        render: function (d, t) {
            if (t === "display" || t === "filter") {
                return convert_1.default.distance.localString(d.max - d.min);
            }
            else {
                return d.max - d.min;
            }
        }
    };
    var placeColumn = {
        render: function (d, t, row) {
            if (t === "filter") {
                return (row.location || "") + " " + (0, places_1.formatPlace3)(row.place);
            }
            else {
                return row.location || "";
            }
        }
    };
    var suitColumn = {
        data: "suit",
        render: {
            _: function (d, t, row) { return d || row.canopy || ""; },
            filter: function (d, t, row) { return (d || "") + " " + (row.canopy || ""); }
        }
    };
    var errorColumn = {
        render: function (d, t, row) {
            var dist = null;
            if (row && row.place) {
                if (row.place.objectType === "DZ" && row.stats.land) {
                    dist = (0, geo_1.distance)(row.place.lat, row.place.lng, row.stats.land.lat, row.stats.land.lng);
                }
                else if (row.stats.exit) {
                    dist = (0, geo_1.distance)(row.place.lat, row.place.lng, row.stats.exit.lat, row.stats.exit.lng);
                }
            }
            if (dist !== null) {
                if (t === "display" || t === "filter") {
                    return convert_1.default.distance.localString(dist);
                }
                else {
                    return dist;
                }
            }
            else {
                return "";
            }
        }
    };
    var basicColumns = [
        dateColumn,
        altColumn,
        placeColumn,
        suitColumn,
        {
            data: "jumpType",
            render: function (d, t, row) { return (0, track_1.jumpType)(row); }
        }
    ];
    var adminColumns = [
        dateColumn,
        altColumn,
        {
            data: "stats.time",
            render: function (d) { return ((d.max - d.min) / 60000).toFixed(1) || ""; }
        },
        placeColumn,
        // {
        //   data: "place.objectType",
        //   render: (d: string) => d || ""
        // },
        {
            data: "jumpType",
            render: {
                _: function (d, t, row) {
                    var _a;
                    return d || baseButton(row) + (((_a = row.place) === null || _a === void 0 ? void 0 : _a.objectType) || "");
                },
                filter: function (d, t, row) { var _a; return (d || "") + " " + (((_a = row.place) === null || _a === void 0 ? void 0 : _a.objectType) || ""); },
                sort: function (d, t, row) { return row.jumpType || ""; }
            }
        },
        {
            data: "fileType",
            render: {
                _: function (d) { return d || ""; },
                filter: function () { return ""; } // Don't filter on filetype because BASEline matches BASE
            }
        },
        {
            data: "user_name",
            render: function (d) { return d || "Anon"; }
        },
        errorColumn,
        suitColumn,
        {
            data: "note",
            render: function (d) { return d || ""; }
        },
        {
            data: "labels",
            render: function (d) { return isEmpty(d) ? "" : "Y"; }
        },
        {
            data: "stats.plan",
            render: function (d) { return d ? d.name : ""; }
        },
        {
            data: "track_id",
            render: function (d) { return "<button class=\"btn btn-sm btn-default bad-track\" data-track-id=\"" + d + "\">Bad</button>"; }
        },
        {
            data: "track_id",
            render: function (d, t, row) { return row.reason || ""; }
        }
    ];
    // Check for empty object, because javascript
    var isEmpty = function (obj) {
        for (var key in obj)
            return false;
        return true;
    };
    function baseButton(track) {
        var _a;
        if (((_a = track.place) === null || _a === void 0 ? void 0 : _a.objectType) === "PG") {
            return "<button class=\"btn btn-sm btn-default set-jump-type\" data-track-id=\"" + track.track_id + "\" data-jump-type=\"PG\">PG</button>";
        }
        else {
            return "<button class=\"btn btn-sm btn-default set-jump-type\" data-track-id=\"" + track.track_id + "\" data-jump-type=\"BASE\">B</button>" +
                ("<button class=\"btn btn-sm btn-default set-jump-type\" data-track-id=\"" + track.track_id + "\" data-jump-type=\"Skydive\">S</button>");
        }
    }
    // tslint:disable-next-line:max-line-length
    var emptyTable = "No tracks.<br>Upload a GPS track using the upload box above, or get the <a href=\"https://play.google.com/store/apps/details?id=com.platypii.baseline\">android app</a>.";
    var language = {
        emptyTable: emptyTable,
        info: "Showing _START_ to _END_ of _TOTAL_ tracks",
        infoEmpty: "Showing 0 to 0 of 0 tracks",
        infoFiltered: "(filtered from _MAX_ total tracks)",
        lengthMenu: "Show _MENU_ tracks"
    };
    function init(userId) {
        // Tables with data loaded by ajax
        for (var _i = 0, _a = (0, dom_1.q)(".track-table"); _i < _a.length; _i++) {
            var table = _a[_i];
            $(table).DataTable({
                ajax: function (data, callback) {
                    trackStore.getUserTracks(userId).then(function (tracks) { return callback({ data: tracks }); });
                },
                columns: basicColumns,
                language: language,
                stateSave: true
            });
        }
    }
    exports.init = init;
    function initExit(lat, lng) {
        // Add exit track list
        $(".exit-table").DataTable({
            ajax: function (data, callback) {
                trackStore.getExitTracks(lat, lng).then(function (tracks) { return callback({ data: tracks }); });
            },
            columns: __spreadArray(__spreadArray([
                {
                    data: "user_name",
                    render: function (d) { return d || "Anon"; }
                }
            ], basicColumns, true), [
                errorColumn
            ], false),
            language: language,
            order: [[1, "desc"]]
        });
    }
    exports.initExit = initExit;
    function initAdmin() {
        for (var _i = 0, _a = (0, dom_1.q)(".track-table-admin"); _i < _a.length; _i++) {
            var table = _a[_i];
            var url = table.getAttribute("data-track-list-url");
            $(table).DataTable({
                ajax: {
                    url: url,
                    cache: true // Removes the ?_=1533878367559 query param
                },
                columns: adminColumns,
                order: [[0, "desc"]]
            });
        }
    }
    exports.initAdmin = initAdmin;
});
//# sourceMappingURL=/assets/javascripts/baseline/tables.js.map;
